/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type unit_option_limit_full = {
  id: number;
  army_organisation_id: number | null;
  limit: unit_option_limit_full.limit;
  selector_model: unit_option_limit_full.selector_model;
  min: number;
  max: number;
  key: string | null;
  repeated_by: number | null;
};
export namespace unit_option_limit_full {
  export enum limit {
    UNITS = 'Units',
    MODEL = 'Model',
    MODEL_BY_UNIT = 'ModelByUnit',
    ITEM_BY_ARMY = 'ItemByArmy',
    ITEM_BY_MODEL = 'ItemByModel',
  }
  export enum selector_model {
    QUANTITY = 'Quantity',
    SELECTION = 'Selection',
  }
}
